import { useEffect, useRef } from 'react';
import  styles from './style.module.css';
import ContactBtn from '../../compoenets/ContactBtn';
import figureVideo from '../../assets/signUp_4k_02.mp4';

const signUpItems=[
    "이름",
    "이메일",
    "부서명",
    "가입 목적",
]

export default function SignUp(){
    const figureRef=useRef(null);

    useEffect(() => {
      if(figureRef.current.played.length === 0 ) figureRef.current.play();

      const timer = setInterval(() => {
        let figureRefPlay=figureRef.current.play();
        if (figureRefPlay !== undefined) { figureRefPlay.then((_) => {}).catch((error) => {}); }
      }, 2000);
      return () => {
        clearInterval(timer);
      };
    }, []);

    return(
        <div className={styles['wrap']}>
        <div className={styles['main']}>
            <div className={styles["figure"]}>
                <video ref={figureRef} muted className={styles["figure-video"]}>
                    <source src={figureVideo} type="video/mp4"/>
                </video>
            </div>
            <div className={styles['body']}>
                <p className={styles['intro']}>
                    <span>SAMUEL</span><span>은 AI Model의 설계와 학습을 제공하는</span>
                    <br></br>
                    <span>Federated Learning Workspace입니다.</span>
                </p>
                <div className={styles['info']}>
                    <div className={styles['info-title']}>
                        <div className={styles['info-title-icon']}></div>
                        <p>
                        <span>SAMUEL</span>
                        <span>을 만나는 방법</span>
                        </p>
                    </div>
                    <span className={styles['info-intro']}>
                        회원가입을 위해 아래의 양식에 맞춰 관리자에게 메일로 요청주시면
                        <br></br>
                        검토 후 계정을 생성해 드립니다.
                    </span>
                    <div className={styles['info-item-wrap']}>
                        {signUpItems.map((item,index)=>(
                        <div className={styles['info-item']}>
                            <div className={styles['info-item-icon']}></div>
                            <span key={index}>{item}</span>
                        </div>
                        ))}
                    </div>
                    <ContactBtn/> 
                </div>
                    
            </div>
        </div>
        </div>
    )
}